module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-corrective-maintenance/master-corrective-maintenance.component.scss
// module id = ./src/app/master/master-corrective-maintenance/master-corrective-maintenance.component.scss
// module chunks = main